import InputSearchOrders from './InputSearchOrders';
import FilterOrdersProducer from './FilterOrdersProducer';
import FilterOrdersPublisher from './FilterOrdersPublisher';
import FilterOrdersDate from './FilterOrdersDate';
import FilterOrdersCheckbox from './FilterOrdersCheckbox';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { removeEmptyObject } from '../../services/help';
import { TbZoomReset } from 'react-icons/tb';
import { IoMdRefresh } from 'react-icons/io';

const FilterOrders = ({ isAdmin = false, showDetails }) => {

    const [producerID, setProducerID] = useState()
    const [publisherId, setPublisherId] = useState()
    const [dateFrom, setDateFrom] = useState()
    const [dateTo, setDateTo] = useState()
    const [searchQuery, setSearchQuery] = useState()
    const [queries, setQueries] = useState({})
    const [checkboxDefVal, setCheckboxDefVal] = useState(true)

    const [searchParams, setSearchParams] = useSearchParams()
    const defValProducer = searchParams.get('producerId')
    const defValPublisher = searchParams.get('publisherId')
    const defdateValFrom = searchParams.get('regDateFrom')
    const defdateValTo = searchParams.get('regDateTo')


    useEffect(() => showDetails(checkboxDefVal), [checkboxDefVal])

    useEffect(() => {
        setQueries(removeEmptyObject({
            searchTerm: searchQuery ? searchQuery : null,
            producerId: producerID ? producerID : null,
            publisherId: publisherId ? publisherId : null,
            regDateFrom: dateFrom ? dateFrom : null,
            regDateTo: dateTo ? dateTo : null,
        }))

    }, [producerID, searchQuery, publisherId, dateFrom, dateTo])

    const handleSubmitForm = (event) => {
        event.preventDefault()
        setSearchParams(queries)
    }

    const handleResetForm = () => {
        setSearchParams({})
        showDetails(true)
        setCheckboxDefVal(true)
    }


    return (
        <>
            <div>
                <form onSubmit={handleSubmitForm} style={{ position: 'relative', zIndex: 999 }}>
                    <InputSearchOrders pullback={setSearchQuery} />
                    <div className='fh'>
                        <div className='filterItems'>
                            {isAdmin ? <FilterOrdersProducer defaultValue={defValProducer} pullback={setProducerID} /> : ''}
                            {isAdmin ? <FilterOrdersPublisher defaultValue={defValPublisher} pullback={setPublisherId} /> : ''}

                            <FilterOrdersDate dateValFrom={setDateFrom} dateValTo={setDateTo} defaultdateValFrom={defdateValFrom} defaultdateValTo={defdateValTo} />
                            <FilterOrdersCheckbox pullback={setCheckboxDefVal} defaultValue={checkboxDefVal} />
                            <div className="flex" style={{ gap: 10 }}>
                                <button style={{ height: '38px', paddingTop: '9px' }}>نمایش نتایج</button>
                                <button style={{ height: '38px', paddingTop: '9px', minWidth: 'fit-content', fontSize: '20px', lineHeight: 0, background: '#95a3b3', border: 'none' }} type='button' onClick={handleResetForm}><IoMdRefresh /></button>
                            </div>
                        </div>
                    </div>
                </form>
                <hr style={{ borderColor: '#cdcdcd', opacity: 1, margin: '25px 0' }} />
            </div>
        </>
    );
}

export default FilterOrders;